export default "__VITE_ASSET__53e41bea__"